import React, { PureComponent } from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import { FacebookShareButton } from 'react-share';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import userSettingService from '../../../../../../core/services/Common/UserSettingService';
import Loading from '../../../../../common/loading/Loading';
import SkypeShareButton from '../../../../../common/social-share-button/SkypeShareButton';
import ZaloShareButton from '../../../../../common/social-share-button/ZaloShareButton';
import { withWidget } from '../../../context';
import { capitalizeFirstLetter } from '../../helper';

class SharePopupContent extends PureComponent {
  state = {
    isCopied: false,
    isShared: false,
    isLoading: true,
    url: '',
  };

  input = React.createRef();

  componentDidMount() {
    this.shareTemplateRequest();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { url } = this.state;
    if (url && !prevProps.url) {
      this.initShareZalo();
    }
  }

  initShareZalo = () => {
    const script = document.createElement('script');
    script.src = 'https://sp.zalo.me/plugins/sdk.js';
    document.body.appendChild(script);
    script.onload = () => {
      document.body.removeChild(script);
    };
  };

  shareTemplateRequest = () => {
    const { widget, theme, locale } = this.props;
    widget.save(chartState => {
      chartState.theme = capitalizeFirstLetter(theme);
      chartState.locale = locale;
      userSettingService
        .getChartLayoutShareInfo({
          chartLayout: JSON.stringify(chartState),
        })
        .then(res => {
          const searchParams = new URLSearchParams(res.result);
          const url = `${
            window.location.origin
          }/charting?${searchParams.toString()}`;
          this.setState({
            url,
            isLoading: false,
          });
        });
    });
  };

  handleClickOutside() {
    const { changeSharePopupStatus } = this.props;
    changeSharePopupStatus(false);
  }

  onCopyClick = e => {
    e.preventDefault();
    e.stopPropagation();
    this.input.current.select();
    document.execCommand('copy');
    this.input.current.blur();
    this.setState({
      isCopied: true,
    });
  };

  onContentClick = () => {
    this.setState({
      isCopied: false,
    });
  };

  render() {
    const { isLoading } = this.state;
    const { isCopied, url } = this.state;

    return (
      <div onClick={this.onContentClick} className="content">
        {isLoading && <Loading />}
        <div className={isLoading ? 'blur' : ''}>
          <div className="title">
            <Translate
              value={
                isCopied
                  ? 'charting.copyToClipboard'
                  : 'charting.shareChartLayout'
              }
            />
          </div>

          <div className="share-wrapper">
            <div className="share-link">
              <input
                ref={this.input}
                value={url}
                type="text"
                className="form-control"
                readOnly
              />
              <button onClick={this.onCopyClick} className="btn btn-primary">
                <Translate value="charting.copy" />
              </button>
            </div>

            <div className="share-button">
              <FacebookShareButton url={url}>
                <i className="icon-facebook" />
              </FacebookShareButton>
              <SkypeShareButton url={url}>
                <i className="icon-skype" />
              </SkypeShareButton>
              <ZaloShareButton url={url}>
                <i className="icon-zalo" />
              </ZaloShareButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SharePopupContent.propTypes = {
  changeSharePopupStatus: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  theme: state.theme,
  locale: state.i18n.locale,
});

export default compose(
  withWidget,
  connect(mapStateToProps),
  enhanceWithClickOutside,
)(SharePopupContent);
